import {Navigate} from "react-router-dom";
import {PlatformLoader} from '@flexinet/ui-components';
import {useAuth} from "../../../hooks/useAuth.ts";
import {RedirectToSignIn} from "../../../components/RedirectToSignIn.tsx";

// FNP-1708: "/" is also where the broker returns with a code, so it must wait
// for the session to resolve before deciding the visitor is anonymous.
export const PublicHomePage = () => {
    const {status} = useAuth();

    if (status === 'resolving') {
        return <PlatformLoader message='Signing in...'/>;
    }

    if (status === 'anonymous') {
        return <RedirectToSignIn/>;
    }

    return <Navigate to={'/dashboard'}/>;
};
